export const RESOURCE_TYPE_SECURITY = 'SOFTWARE_SECURITY';
